export enum InputType {
	TEXT = 1,
	NUMERIC = 2,
}
